import React from "react";
import classNames from "classnames";
//import * as _ from "lodash";

import "./AnswerOutput.css";

const AnswerOutput = ({ value, disabled, higlighted, isCorrect, isWrong }) => {
  return (
    <div
      className={classNames("AnswerOutput", {
        "--disabled": disabled,
        "--correct": isCorrect,
        "--wrong": isWrong,
        "--higlighted": higlighted,
        "--isAlpha":
          value && typeof value === "string" && value.match(/^[a-z]+$/i),
      })}
    >
      <div className="-input">
        Answer:{" "}
        <span className="-digits">
          {value}
          {!disabled && !isWrong && <span className="-cursor">_</span>}
        </span>
      </div>
      <div className="-feedback">
        {isCorrect && <>Correct</>}
        {isWrong && <>Wrong</>}
      </div>
    </div>
  );
}

export default AnswerOutput;